export const COMPONENTS = [
  { name: 'Button', path: 'button' },
  { name: 'ButtonCancel', path: 'button-cancel' },
  { name: 'ButtonSelect', path: 'button-select' },
  { name: 'Checkbox', path: 'checkbox' },
  { name: 'CheckboxSelect', path: 'checkbox-select' },
  { name: 'Icon', path: 'icon' },
  { name: 'Input', path: 'input' },
  { name: 'Message', path: 'message' },
  { name: 'Modal', path: 'modal' },
  { name: 'ModalAction', path: 'modalaction' },
  { name: 'Pagination', path: 'pagination' },
  { name: 'Radio', path: 'radio' },
  { name: 'Select', path: 'select' },
  { name: 'Steppers', path: 'steppers' },
  { name: 'Switch', path: 'switch' },
  { name: 'Tabs', path: 'tabs' },
  { name: 'Tag', path: 'tag' },
  { name: 'TagSelect', path: 'tagselect' },
  { name: 'Toast', path: 'toast' },
  { name: 'Tooltip', path: 'tooltip' }
]

export const ICONS = [
  'action',
  'add',
  'arrow',
  'arrowReturn',
  'arrowRight',
  'choiceIcon',
  'closeIcon',
  'contentViewBlock',
  'contentViewList',
  'cursorMoveVertical',
  'deleteIcon',
  'imageIcon',
  'navAction',
  'navFirst',
  'navLast',
  'navNext',
  'navPrev',
  'pencil',
  'sectionIcon',
  'subtract',
  'textIcon'
]

export const COLORS = [
  {
    label: 'primary',
    color: '#1f8efa'
  },
  {
    label: 'success',
    color: '#00c396'
  },
  {
    label: 'danger',
    color: '#ff3743'
  },
  {
    label: 'info',
    color: '#0d9cff'
  },
  {
    label: 'warning',
    color: '#ffbd2e'
  },
  {
    label: 'link',
    color: '#05c5db'
  }
]
